
define('app/home/unknown/unknownHomeMain',[
	'domReady',
	'app/common/setup',
	'app/home/unknown/unknownHomeApp',
	'unknown/unknownSetup'
], function(domReady, Setup, UnknownHomeApp, UnknownSetup){
	domReady(function () {
		Setup.initialize();
		UnknownSetup.initialize();
		UnknownHomeApp.initialize();
    });
});